module.exports = __webpack_public_path__ + "static/media/Networking.d2912d31.gif";